import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import PlayersIndex from "@/pages/PlayersIndex";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/players/")({
  head: () => ({
    meta: [
      { title: "Football Player Stats, Form & Ratings | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["players"] }).meta },
      { name: "description", content: "Player form, impact ratings and availability — the same data feeding Statlign's engine. See exactly which players are moving the odds." },
      { property: "og:title", content: "Football Player Stats, Form & Ratings | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Player form, impact ratings and availability — the same data feeding Statlign's engine. See exactly which players are moving the odds." },
      { name: "twitter:title", content: "Football Player Stats, Form & Ratings | Statlign" },
      { name: "twitter:description", content: "Player form, impact ratings and availability — the same data feeding Statlign's engine. See exactly which players are moving the odds." },
    ],
  }),
  component: () => (
    <MainLayout>
      <PlayersIndex />
    </MainLayout>
  ),
});
